export const urlIdParamToId = (urlId: string | undefined): string | undefined => {
  return urlId?.match(/(\w|\d)+$/i)?.[0];
};
